import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. La guía está pensada para principiantes y te acompaña paso a paso desde cero.'
}, {
  q: '¿Necesito saber dibujar?',
  a: 'No. Incluye plantillas para practicar y más de 300 plantillas listas para imprimir. Las colocas debajo del vidrio, acetato o superficie transparente y las usas como guía.'
}, {
  q: '¿Cómo se usan las plantillas?',
  a: 'Las descargas, las imprimes y las colocas debajo de la superficie que vas a pintar. Después sigues el diseño con el contorno y rellenas con color.'
}, {
  q: '¿Los materiales se consiguen fácil?',
  a: 'Sí. La guía te muestra materiales simples, alternativas económicas y qué comprar primero para empezar sin complicarte.'
}, {
  q: '¿Necesito máquinas o un taller?',
  a: 'No. Puedes empezar desde casa, con una mesa de trabajo, materiales básicos y piezas simples como frascos, acetatos o vidrios pequeños.'
}, {
  q: '¿Qué puedo crear con falso vitral?',
  a: 'Portavelas, frascos decorativos, atrapasoles, espejos, cuadros, vajilla decorada, adornos para ventanas, souvenirs y regalos personalizados.'
}, {
  q: '¿Puedo vender las piezas que aprenda a hacer?',
  a: 'Sí. El producto incluye ideas para vender y una guía de emprendimiento para ayudarte a calcular precios, armar combos y ofrecer tus piezas.'
}, {
  q: '¿La guía enseña a vender?',
  a: 'Sí. Incluye un bono de emprendimiento con consejos para precios, fotos, Instagram, WhatsApp, pedidos personalizados, entregas y fechas especiales.'
}, {
  q: '¿Es un producto físico?',
  a: 'No. Es un producto 100% digital. Recibes el acceso para descargar el material y verlo desde tu celular, computadora o tablet.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'El acceso es inmediato después de la compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-deco-cream py-14 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-48" data-mp="2kvwzukg27v5z">
      <div className="max-w-2xl mx-auto" data-id="element-49" data-mp="2ktu0h9t0opol">
        <p className="text-center text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-4" data-id="element-50" data-mp="2fwahxxpadqqu">
          Antes de comprar
        </p>
        <h2 className="text-center font-serif text-2xl sm:text-4xl text-deco-forest font-semibold mb-12" data-id="element-51" data-mp="2avwb2izf8mue">
          Preguntas <span className="italic text-deco-brick" data-id="element-52" data-mp="33mely66dzsid">frecuentes</span>
        </h2>

        <div className="divide-y divide-deco-forest/10 border-y border-deco-forest/10" data-id="element-53" data-mp="33klforzoraaw">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} data-id="element-54" data-mp="2unsypxpyzpb9" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full py-5 flex items-center justify-between gap-6 text-left group" data-id="element-55" data-mp="1n7wozwd21km5">
                  <span className={`font-serif text-sm sm:text-base leading-snug transition-colors duration-200 ${isOpen ? 'text-deco-brick' : 'text-deco-forest'}`} data-id="element-56" data-mp="3uvhl67y1rw90">
                    {faq.q}
                  </span>
                  <Plus size={18} className={`shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45 text-deco-brick' : 'text-deco-forest/40'}`} data-id="element-57" data-mp="chi5hj9ansqs" />
                </button>

                <AnimatePresence initial={false} data-id="element-58" data-mp="veja32yxrqu7">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-59" data-mp="vcf7cocrwxvi">
                      <p className="pb-6 pr-8 text-[13px] sm:text-sm text-deco-forest/65 leading-relaxed" data-id="element-60" data-mp="1ww3i393pkecx">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}